import React, { forwardRef } from "react";
import { MotionButton } from "utils/motion";
import { useRouter } from "next/router";
import { trackBtClick } from "utils/analytics";

const Button = forwardRef(function Button(
  { trackLabel, onClick, href, inverted, ...props },
  ref,
) {
  const { locale, defaultLocale } = useRouter();

  const handleClick = (e) => {
    if (trackLabel) trackBtClick(trackLabel);
    if (onClick) onClick(e);
  };

  const resolvedHref =
    href && locale !== defaultLocale && href.startsWith("/")
      ? `/${locale}${href}`
      : href;

  return (
    <MotionButton
      ref={ref}
      locale={locale}
      {...props}
      {...(href && { as: "a", href: resolvedHref, target: props.target })}
      invert={props.invert || props.colorScheme === "black"}
      onClick={handleClick}
    />
  );
});

export default Button;
